// extracted by mini-css-extract-plugin
export default {"logo":"AdminPortal_logo__HB+0R","burgermenuImg":"AdminPortal_burgermenuImg__dVn0f","burgermenuBtn":"AdminPortal_burgermenuBtn__KYOOG"};